<template>
    <div class="general-modal">
        <BaseModal :padding="isMobileOrTablet ? MODAL_PADDING_MOBILE : MODAL_PADDING_DESKTOP"
                   maxWidth="500px"
                   maxHeight="500px"
                   useContentFullHeight
                   useClickOutsideClose
                   @close="handleClose">
            <template #header/>
            <template #content>
                <div class="general-modal__content general-modal__content--justify-center">
                    <div class="general-modal__image">
                        <img :src="asset_cdn('assets/missions/lucky-reward.svg')"
                             :alt="getTrans('quests-dashboard.reward', 'Reward')"
                             :title="getTrans('quests-dashboard.reward', 'Reward')"
                             width="150"
                             height="150">
                    </div>
                    <div class="general-modal__title">
                        {{ notification?.data?.title || 'Claim your Airdrop' }}
                    </div>
                    <div class="general-modal__subtitle">
                        {{ notification?.data?.subtitle || 'Your\'re eligible for the Season 7 Airdrop! Enter your Binance UID or Coinbase Wallet Address to claim it.' }}
                    </div>
                    <div>
                        Note: Deadline May 11th 23:59 UTC
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="general-modal__actions">
                    <span class="general-modal__action general-modal__action--confirm">
                        <BaseButton v-focus
                                    @click="openNotificationUrl">
                            <Translate translationKey="quests-dashboard.enterNow"
                                       fallback="Enter now"/>
                            🔥
                        </BaseButton>
                    </span>
                </div>
            </template>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import { ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import BaseModal from '@/js/components/BaseModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import BaseButton from '@/js/components/BaseButton.vue';
    import { asset_cdn } from '@/js/helpers/helpers';
    import { getTrans } from '@/js/helpers/getTrans';
    import { Notification } from '@/js/quests/dashboard/types/types';
    import { NotificationModalTypeEnum } from '@/js/quests/dashboard/types/enums';
    import { useUserStore } from '@/js/store/quests/dashboard/UserStore';
    import { MODAL_PADDING_DESKTOP, MODAL_PADDING_MOBILE } from '@/js/quests/global/constants/modal';
    import { dashboardRoutesNames } from '@/js/quests/dashboard/constants/dashboardRoutesNames';

    const modalStore = useModalStore();
    const userStore = useUserStore();
    const router = useRouter();
    const { isMobileOrTablet } = useDeviceSize();

    const notification = ref();

    const handleClose = () => {
        modalStore.toggleModal(ModalEnum.AIRDROP_CLAIM, false);
    };

    const openNotificationUrl = () => {
        if (notification.value?.data?.url) {
            window.location.href = notification.value?.data?.url;
        } else {
            router.push({ name: dashboardRoutesNames.LEADERBOARD_ROUTE_NAME });
        }
        handleClose();
    };

    useModalActive();

    watch(
        () => modalStore.modals[ModalEnum.AIRDROP_CLAIM],
        (newValue) => {
            if (newValue) {
                const allNotifications: Notification[] = userStore?.notifications ?? [];
                const filteredNotifications = allNotifications.filter(
                    (notification) => notification.type === NotificationModalTypeEnum.QuestSeasonUserRewardClaim,
                );
                notification.value = filteredNotifications.length > 0 ? filteredNotifications[0] : null;
            }
        },
        { immediate: true },
    );
</script>

<style scoped lang="scss">
@use "@/js/quests/dashboard/sass/mixins/_modal" as modalMixins;

.general-modal {
    @include modalMixins.modal;

    &__image {
        img {
            width: 150px;
            height: 150px;
        }
    }
}
</style>
